export const CLINICAL_NOTE_DATE_VALIDATOR = 'clinical-note-date-validator';
async function clinicalNoteRegisterDateValidator(value) {
    let message = '';
    let valid = true;
    if (value) {
        const today = new Date();
        const clinicalNoteDate = new Date(value);
        valid = clinicalNoteDate <= today;
        if (!valid) {
            message = 'message.start-date-greater-current-date';
        }
    }
    return [{
            message: message,
            name: CLINICAL_NOTE_DATE_VALIDATOR,
            valid: valid
        }];
}
export default clinicalNoteRegisterDateValidator;
//# sourceMappingURL=clinical-note-register-date-validator.js.map